angular.module("app").directive("tchNetworkSelector", ["ExploitationService", function (ExploitationService) {
	return {
		restrict: "E",
		templateUrl: "common/directives/exploitation/network/tchNetworkSelectorDirective.html",
		replace: true,
		scope: {
			data: "=tchNetworkSelectorData",
			callback: "&tchNetworkSelectorCallback",
			callbackAfterLoad: "&tchNetworkSelectorCallbackAfterLoad", // après le chargement des lignes du network sélectionnée ce callback est appelé
			useCache: "=tchNetworkSelectorCache",
			doNotFetch: "=tchNetworkSelectorDoNotFetch"
		},

		link: function (scope) {

			// Fetch networks avalaible for this user at page loading
			if (scope.data.archiveMode) {
				ExploitationService.getNetworksArchiveMode(scope.data.schemaName).then((response) => {
					scope.data.networks = response.data;
				});
			} else {
				ExploitationService.getNetworks(scope.useCache !== undefined ? scope.useCache : false, scope.data.fetchMosaicData).then((response) => {
					ExploitationService.updateNetworkCache(response.data);
					scope.data.networks = response.data;
				});
			}

			scope.networkSelected = function () {

				scope.callback({network: scope.data.currentNetwork});

				if (!scope.doNotFetch) {
					if (scope.data.currentNetwork) {
						if (scope.data.archiveMode) {
							ExploitationService.getLinesArchiveMode(scope.data.currentNetwork, scope.data.tempSchemaName).then(response => {
								const data = response.data;
								scope.data.lines = data;

								if (!data.some(l => l.id === scope.data.currentLine)) {
									scope.data.routes = {};
									scope.data.courses = {};
									scope.data.currentRoute = undefined;
									scope.data.currentCourse = undefined;
								}

								if (scope.callbackAfterLoad) {
									scope.callbackAfterLoad();
								}
							});
						} else {
							ExploitationService.getLines(scope.data.currentNetwork, scope.useCache !== undefined ? scope.useCache : false, scope.data.fetchMosaicData).then(response => {
								scope.data.lines = response.data;
								if (scope.callbackAfterLoad) {
									scope.callbackAfterLoad();
								}
							});
						}
					} else {
						scope.data.lines = [];
						scope.data.currentLine = undefined;
					}
				}
			};

			// go to network if single
			if(scope.data.networks && scope.data.networks.length === 1){
				scope.data.currentNetwork = scope.data.networks[0].id;
				scope.networkSelected();
			}

			/**
			 * A chaque changement du network on doit recharger les lignes
			 */
			scope.$watch("data.currentNetwork", (newValue, oldValue) => {
				if (scope.data.currentNetwork) {
					scope.networkSelected();
				}
				if (newValue !== oldValue) {
					scope.data.lines = {};
					scope.data.currentLine = undefined;
				}
			})
			
		}
	};
}]);
